module.exports = __webpack_public_path__ + "img/rentini-package.9a0c5287.svg";